import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import portalAuth from './slices/portalAuthSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        portalAuth,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}
  
export default rootReducer
